import { useAppContext } from "../hooks";

function AuthorizedOnly(props) {
  const { data: appContext } = useAppContext();

  for (const role of appContext.userProfiles) {
    if (props[role] || props.roles?.includes(role)) {
      return props.children;
    }
  }
}

export default AuthorizedOnly;
